import DataTable from 'components/DataTable';
import ListWrapper from 'components/ListWrapper';
import Typography from 'components/Typography';
import {DataTableSchemaItem} from 'types';
import Button from 'components/Button';
import styles from './blogs.module.scss';
import useTemplate from './useTemplate';
import BlogPagination from 'components/BlogPagination';

const SCHEMA: DataTableSchemaItem[] = [
  {
    dataKey: 'title',
    header: 'Title',
  },
  // {dataKey: 'image', header: 'Image'},
  {dataKey: 'created_at', header: 'Created Date'},
  {
    dataKey: 'active',
    header: 'Published',
    align: 'right',
  },
  {dataKey: 'view', header: ''},
];

function TemplateList() {
  const {
    data,
    isLoading,
    currentPage,
    setCurrentPage,
    totalPages,
    count,
    pageSize,
    setPageSize,
    onRowClick,
  } = useTemplate();

  return (
    <>
      <div className={styles.header}>
        <Typography variant="h2">Templates</Typography>
        <Button component="a" to="/settings/templates/create" color="blue">
          Add Template
        </Button>
      </div>
      <ListWrapper>
        <DataTable
          onClick={onRowClick}
          schema={SCHEMA}
          data={data}
          loading={isLoading}
        />
        {totalPages > 1 && (
          <BlogPagination
            count={count}
            basePath="/templates"
            page={currentPage}
            total={totalPages}
            setCurrentPage={setCurrentPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
          />
        )}
      </ListWrapper>
    </>
  );
}

export default TemplateList;
